import * as z from "zod";

export const configSchema = z.object({
  AzureAdConfiguration: z.object({
    tenantName: z.string().min(1),
    clientId: z.string().uuid().min(1),
    scopes: z.array(z.string().min(1)),
    policyNames: z.object({
      signIn: z.string().min(1),
      forgotPassword: z.string().min(1),
    }),
  }),
  APP_CONFIG: z.object({
    API_BASE_URL: z.string().regex(/^(?:http(s)?:\/\/)?/),
    SESSION_TIMEOUT: z.string().optional(),
    stats: z.string().optional(),
    FEATURES: z.object({
      LOG_LEVEL: z.string().optional(),
      IS_STATISTICS: z.string().optional(),
      IS_DARK_THEME: z.string().optional(),
    }),
  }),
});
